import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  Button,
  IconButton,
  Drawer,
  List,
  ListItemText,
  Menu,
  MenuItem,
  useMediaQuery,
  Box,
  Typography,
  ListItemIcon,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import logo from "../../assets/logo2.png";
import { useNavigate } from "react-router-dom";
import LocalFloristIcon from "@mui/icons-material/LocalFlorist";
import LandscapeIcon from "@mui/icons-material/Landscape";
import SpaIcon from "@mui/icons-material/Spa";

const Nav = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const navigate = useNavigate();

  const handleDrawerToggle = () => setMobileOpen(!mobileOpen);

  const handleNavigation = (path: string) => {
    navigate(path);
    setMobileOpen(false); // close drawer on mobile
    setAnchorEl(null); // close menu on desktop
  };

  const handleMenuOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => setAnchorEl(null);

  // const menuItems = [
  //   { text: "Home", path: "/" },
  //   { text: "About", path: "/about" },
  // ];
  const menuItems = [
    { text: "Home", scrollToId: "home", mobilePath: "/" },
    { text: "About", scrollToId: "about", mobilePath: "/details" },
  ];


  const productLinks = [
    { text: "Plants", path: "/plants-Categorie" },
    { text: "Stones", path: "/products/stones" },
    { text: "Pots", path: "/products/pots" },
  ];

  const scrollToSection = (id: string) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
      setMobileOpen(false); // close drawer
      setAnchorEl(null); // close menu
    }
  };


  const drawer = (
    <Box sx={{ width: 250 }}>
      <List>
        {menuItems.map((item) => (
          <Button
            key={item.text}
            onClick={() =>
              item.mobilePath
                ? handleNavigation(item.mobilePath)
                : scrollToSection(item.scrollToId!)
            }
            sx={{ width: "100%", textAlign: "left", color: "black" }}
          >
            <ListItemText primary={item.text} />
          </Button>
        ))}

        <ListItemText primary="Products" sx={{ padding: "8px 16px", fontWeight: "bold" }} />
        {productLinks.map((item) => (
          <Button
            key={item.text}
            onClick={() => handleNavigation(item.path)}
            sx={{ width: "100%", textAlign: "left", color: "black", pl: 3 }}
          >
            <ListItemText primary={item.text} />
          </Button>
        ))}
      </List>
    </Box>
  );

  return (
    <>
      <AppBar position="fixed" sx={{ backgroundColor: "#EDEADE", boxShadow: "none" }}>
        <Toolbar sx={{ justifyContent: "space-around" }}>
          {/* Logo and Brand */}
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <img src={logo} alt="Logo" style={{ height: "40px", width: "auto", objectFit: "contain" }} />
            <Typography variant="h6" sx={{ color: "#333333", fontWeight: "500" }}>
              Jabal Amel Nursery
            </Typography>
          </Box>

          {/* Desktop Navigation */}
          {isMobile ? (
            <IconButton color="inherit" onClick={handleDrawerToggle} sx={{ color: "#333333" }}>
              <MenuOutlinedIcon fontSize="medium" />
            </IconButton>
          ) : (
            <>
              <Box sx={{ display: "flex", gap: 2 }}>
                {menuItems.map((item) => (
                  <Button
                    key={item.text}
                    onClick={() => scrollToSection(item.scrollToId)}
                    sx={{
                      color: "#333333",
                      fontSize: "14px",
                      fontWeight: "500",
                      padding: "10px 24px",
                      borderRadius: "50px",
                      "&:hover": { background: "rgba(245,237,227,255)" },
                    }}
                  >
                    {item.text}
                  </Button>
                ))}

                <Button
                  onClick={handleMenuOpen}
                  sx={{
                    color: "#333333",
                    fontSize: "14px",
                    fontWeight: "500",
                    padding: "10px 24px",
                    borderRadius: "50px",
                    "&:hover": { background: "rgba(245,237,227,255)" },
                  }}
                >
                  Products
                </Button>

                <Menu
                  anchorEl={anchorEl}
                  open={Boolean(anchorEl)}
                  onClose={handleMenuClose}
                  PaperProps={{
                    elevation: 3,
                    sx: {
                      borderRadius: "16px",
                      padding: "8px 0",
                      minWidth: 200,
                    },
                  }}
                >
                  <MenuItem onClick={() => handleNavigation("/plants-Categorie")}>
                    <ListItemIcon>
                      <LocalFloristIcon fontSize="small" sx={{ color: "#6DA34D" }} />
                    </ListItemIcon>
                    <ListItemText primary="Plants" />
                  </MenuItem>

                  <MenuItem onClick={() => handleNavigation("/products/stones")}>
                    <ListItemIcon>
                      <LandscapeIcon fontSize="small" sx={{ color: "#8D6E63" }} />
                    </ListItemIcon>
                    <ListItemText primary="Stones" />
                  </MenuItem>

                  <MenuItem onClick={() => handleNavigation("/products/pots")}>
                    <ListItemIcon>
                      <SpaIcon fontSize="small" sx={{ color: "#A1887F" }} />
                    </ListItemIcon>
                    <ListItemText primary="Pots" />
                  </MenuItem>
                </Menu>
              </Box>

              <Button
                sx={{
                  color: "#333333",
                  background: "rgba(245,237,227,255)",
                  borderRadius: "50px",
                  padding: "10px 24px",
                  fontSize: "12px",
                  fontWeight: "500",
                  lineHeight: "120%",
                  "&:hover": { color: "white", backgroundColor: "black" },
                }}
              >
                Contact us
              </Button>
            </>
          )}
        </Toolbar>
      </AppBar>


      <Drawer
        variant="temporary"
        anchor="right"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{ keepMounted: true }}
        sx={{
          display: { xs: "block", md: "none" },
          "& .MuiDrawer-paper": {
            boxSizing: "border-box",
            width: 250,
            backgroundColor: "#EDEADE",
            color: "#01411C"
          },
        }}
      >
        {drawer}
      </Drawer>
    </>
  );
};

export default Nav;
